import http from "@/services/http";
import { featureFlags } from "@/config/env";
import { mockManager } from "@/services/mock";

export interface MediaCiteItem {
  site_name: string;
  domain: string;
  domainId: string;
  rate: number;
}

export interface MediaCiteParams {
  brandId?: string;
  categoryId: string;
  days?: number;
  modelId?: string;
}

export interface MediaCiteResponse {
  code: number;
  message: string;
  data: MediaCiteItem[];
}

export const mediaCiteApi = {
  async getMediaCite(params: MediaCiteParams): Promise<MediaCiteItem[]> {
    if (featureFlags.enableMock) {
      return await mockManager.getMediaCite(params);
    }

    try {
      const res = await http.get<MediaCiteResponse>("data/cite/media", {
        params,
      });
      if (!res?.data?.data) return [];
      return res.data.data;
    } catch (err) {
      // 回退到 mock，保证可用
      return await mockManager.getMediaCite(params);
    }
  },
};

export default mediaCiteApi;

// 表格友好型数据结构
export interface MediaCiteRow {
  key: number;
  media: string;
  domain: string;
  ratio: string;
}

// 将业务排序与映射逻辑下沉到 API 层
export async function getMediaCiteRows(
  params: MediaCiteParams
): Promise<MediaCiteRow[]> {
  const items = await mediaCiteApi.getMediaCite(params);
  return items
    .slice()
    .sort((a, b) => b.rate - a.rate)
    .map((item, idx) => ({
      key: idx + 1,
      media: item.site_name,
      domain: item.domain,
      domainId: item.domainId,
      ratio: `${item.rate.toFixed(2)}%`,
    }));
}
